{
  "cms.create.articleTeaser.tabCard": "New home card",
  "cms.create.articleTeaser.tabButton": "New home button",
  "cms.create.card.heading": "New home card",
  "cms.create.card.next": "Next",
  "cms.create.page.heading": "New page",
  "cms.create.page.categoryMissing": "The \"tyosuhde\" content category was not found. The page cannot be created until the category exists.",
  "cms.create.page.categoryLoading": "Loading categories…",
  "cms.create.page.categoriesError": "Loading categories failed. Try again later.",
  "cms.create.page.slugCollisionWarning": "A page with this or a nearly identical title already exists. The page cannot be created until you change the title.",
  "cms.create.back": "Back",
  "cms.create.cancel": "Cancel",
  "cms.create.submit": "Create draft",
  "cms.create.committing": "Creating…",
  "cms.create.savedToDrafts": "Saved to the Drafts list",
  "cms.create.error.page": "Creating the page failed. Try again.",
  "cms.create.error.slugCollision": "A page with this or a nearly identical title already exists. Change the title and try again.",
  "cms.create.error.partial": "The page was created, but creating the home card failed.",
  "cms.create.error.schedule": "The content was saved, but not all schedules could be saved.",
  "cms.create.partial.openCreated": "Go to edit",
  "cms.create.partial.retrySchedule": "Retry scheduling",
  "cms.create.partial.retryCard": "Retry card",
  "cms.create.previewPlaceholder": "The preview appears once the content has been saved.",
  "cms.create.benefit.heading": "New benefit/discount",
  "cms.create.benefit.categoryMissing": "The \"jasenyys\" content category was not found. The benefit cannot be created until the category exists.",
  "cms.create.error.standalone": "Content creation failed. Please try again.",
  "cms.create.error.title": "Title is required (max 200 characters).",
  "cms.create.sidebarLink.heading": "New home button",
  "cms.create.sidebarLink.next": "Next",
  "cms.create.sidebarLink.error.partial": "The page was created, but creating the button failed.",
  "cms.create.sidebarLink.partial.retryButton": "Retry button",
  "cms.create.sidebarLink.categoryMissing": "The \"lakikaveri\" content category was not found. The button cannot be created until the category exists.",
  "cms.create.sidebarLink.pagesError": "Loading the page list failed. A button pointing to a page cannot be created right now. Try again later.",
  "cms.create.templatePicker.backToPageEditing": "Back to page editing",
  "cms.create.templatePicker.label": "Choose a link or ready page template",
  "cms.create.templatePicker.fixedLabel": "Choose a ready page template",
  "cms.create.templatePicker.contact": "Contact us",
  "cms.create.templatePicker.benefits": "Benefits and discounts",
  "cms.create.templatePicker.videos": "Lakikaveri videos",
  "cms.create.templatePicker.destination": "The card/button leads to the selected destination",
  "cms.create.templatePicker.loadError": "Loading page templates failed.",
  "cms.create.templatePicker.selectedLoadError": "Loading the selected page template failed.",
  "cms.create.templatePicker.retry": "Try again",
  "cms.create.templatePicker.loadMore": "Show more templates",
  "cms.create.templatePicker.loading": "Loading page templates…",
  "cms.create.templatePicker.replaceTitle": "Replace unsaved changes?",
  "cms.create.templatePicker.replaceDescription": "The selection changes only the unsaved create form.",
  "cms.create.templatePicker.cancel": "Cancel",
  "cms.create.templatePicker.continue": "Continue",
  "cms.create.templatePicker.locale.fi": "Use Finnish content language",
  "cms.create.templatePicker.locale.sv": "Use Swedish content language",
  "cms.create.templatePicker.locale.en": "Use English content language",
  "cms.create.videoListing.heading": "New video",
  "cms.create.videoListing.categoryMissing": "The \"lakikaveri\" video category was not found. The video cannot be created until the category exists."
}
